export default __webpack_public_path__ + "static/media/pt-serif-v12-latin-regular.eeabdec5.woff2";